export default __webpack_public_path__ + "static/media/plus.09bf4b97.png";